import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import Button from "../Button";
import Menu from "../Menu";
import classNames from "classnames";
import { useStyles } from "./styles";
export const ButtonDropDown = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    options,
    id,
    className,
    fullWidth,
    color,
    MenuProps
  } = props;
  const classes = useStyles(props);
  const renderedOptions = [...options];
  const defaultOption = renderedOptions.shift();
  const calculatedColor = (defaultOption ? defaultOption.color || color : color) || "default";
  const disabled = defaultOption && "disabled" in defaultOption && defaultOption.disabled;
  const primaryClassName = defaultOption && "className" in defaultOption ? defaultOption.className : undefined;
  return defaultOption ? /*#__PURE__*/React.createElement("div", {
    className: classNames("prmbl-buttonDropDown", classes.root, className, {
      [classes.fullWidth]: fullWidth
    }),
    id: id
  }, /*#__PURE__*/React.createElement(Button, _extends({
    color: calculatedColor
  }, defaultOption, {
    fullWidth: fullWidth,
    className: classNames("prmbl-buttonDropDown-primary", primaryClassName)
  })), renderedOptions.length > 0 && /*#__PURE__*/React.createElement("span", {
    className: classNames(classes.menuButtonRoot, disabled ? classes.disabled : classes[calculatedColor])
  }, /*#__PURE__*/React.createElement(Menu, _extends({
    id: `${id}-dropDownMenu`,
    className: classNames("prmbl-buttonDropDown-menu"),
    classes: {
      item: classes.itemWrap,
      paper: classes.buttonMenu,
      button: classes.menuButton
    },
    icon: /*#__PURE__*/React.createElement(ArrowDropDown, null),
    type: "topbar"
  }, MenuProps, {
    ref: ref,
    items: renderedOptions.map((option, index) => ({
      children: /*#__PURE__*/React.createElement(Button, _extends({
        color: color,
        className: classes.menuItem,
        fullWidth: true
      }, option)),
      onClick: () => {
        // do nothing
      }
    }))
  })))) : null;
});
ButtonDropDown.displayName = "ButtonDropDown";
export default ButtonDropDown;